import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import SelectFieldPrioritization from 'Components/ComponentLibrary/Components/Uncategorized/SelectFieldPrioritization';

const hiddenFieldNames = [];

export default fr.metaOverride({ base: BaseOverride })
  .overrideAll({
    _customHelperProps: {
      showRequiredHelperText: false,
    },
  })
  .typeOverride('multipicklist', {
    _component: () => SelectFieldPrioritization,
  })
  .nameOverride(name => hiddenFieldNames.includes(name), {
    hidden: true,
  });
